var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{attrs:{"placement":"bottom-end","category":"tertiary","aria-label":_vm.__('More actions'),"icon":"ellipsis_v","no-caret":""}},[(_vm.canWriteModelRegistry)?_c('delete-model-version-disclosure-dropdown-item',{attrs:{"model-version":_vm.modelVersion},on:{"delete-model-version":_vm.deleteModelVersion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }